export default "__VITE_ASSET__BCsHIzeR__"